import {Component} from '@angular/core';
import {InlineNotificationService} from "./inline-notification.service";
import {IoniconsOutline, NotificationType, UiNotification} from "@pt/pt-models";
import {TranslateModule} from "@ngx-translate/core";
import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";
import {debounceTime, Subject} from "rxjs";
import {IonicModule} from "@ionic/angular";

@Component({
  standalone: true,
  imports: [
    TranslateModule,
    NgbCollapse,
    IonicModule
  ],
  selector: 'pt-inline-notification',
  preserveWhitespaces: false,
  styles: [`
    .inline-notification {
      gap: .5rem;
      display: flex;
      border-radius: 3px;
      height: fit-content;
      align-items: center;
      padding: 4px 16px 4px 6px;
    }
    .divider-line{
      top: 0;
      bottom: 0;
      width: 2px;
      position: absolute;
    }

    .icon-line {
      font-size: 18px;
      margin-left: .5rem;
    }
  `],
  template: `
    <div [ngbCollapse]="collapse && !mouseOver" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
      <div class="inline-notification" [style.background-color]="backgroundColor">
        <div class="d-flex position-relative">
          <div class="divider-line" [style.background-color]="borderColor"></div>
          <ion-icon class="icon icon-line" [name]="notificationIcon" [style.color]="borderColor"></ion-icon>
        </div>
        <div>
          <span class="text-black-50">{{ title | translate }}</span>
          <p class="m-0">{{ message | translate }}</p>
        </div>
      </div>
    </div>
  `,
})

export class InlineNotificationComponent {

  private autoHide$: Subject<void> = new Subject<void>();

  public title?: string;
  public message?: string;
  public collapse = true;
  public mouseOver = false;
  public borderColor = 'transparent';
  public backgroundColor = 'transparent';
  public notificationIcon = IoniconsOutline.infoCircle;


  constructor(private service: InlineNotificationService) {
    this.service.listenNotification().subscribe((notification) => {
      this.title = notification.title;
      this.message = notification.message;
      this.setConfigStyle(notification.type);
      this.checkCollapse(notification);
    });

    this.autoHide$.pipe(
      debounceTime(3000)
    ).subscribe(() => {
      if (!this.collapse)
        this.collapse = true;
    });
  }

  private setConfigStyle(type: NotificationType) {
    switch (type) {
      case NotificationType.success:
        this.borderColor = '#08bb89';
        this.notificationIcon = IoniconsOutline.circleCheck;
        break;
      case NotificationType.info:
        this.borderColor = '#70b6f6';
        this.notificationIcon = IoniconsOutline.infoCircle;
        break;
      case NotificationType.warning:
      case NotificationType.error:
        this.borderColor = '#ffc700';
        this.notificationIcon = IoniconsOutline.warningCircle;
        break;
    }
    this.backgroundColor = `color-mix(in srgb, ${this.borderColor} 10%, transparent 0%)`;
  }

  private checkCollapse(notification: UiNotification) {
    const validTitle = notification.title != null && notification.title.length > 0;
    const validMessage = notification.message != null && notification.message.length > 0;
    this.collapse = !(validTitle || validMessage);
    this.autoHide$.next();
  }

  onMouseOver() {
    this.mouseOver = true;
  }

  onMouseOut() {
    this.mouseOver = false;
  }
}
